/** @format */

import React, { Fragment, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FadeLoader } from "react-spinners";
import { profileSelector } from "store/reducers/ProfileReducer";
import { Row, Col, Card } from "react-bootstrap";
import FellowLayout from "../../../Fellow";
import { useNavigate, useParams } from "react-router-dom";
import { getProviderProfile } from "store/actions/profile";
import { Path } from "utils/constant.data";
import { useGetWebinarQuery } from "store/services/adminAPI";
import EmptyNotice from "component/ErrorNotice";
import course1 from "images/courses/cohort2.jpg";
import { Link } from "react-router-dom";
import { ReactComponent as PlayIcon } from "images/svg/paly.svg";
import { ReactComponent as BackIcon } from "images/svg/back.svg";
import dayjs from "dayjs";
import ModalVideo from "react-modal-video";
import { extractYouTubeVideoId } from "utils/functions";
import { ReactComponent as SearchIcon } from "images/svg/search.svg";
import { capitalize } from "utils/strings";

const FellowWebinar = () => {
  const dispatch = useDispatch();
  const { profileInfo, isLoading } = useSelector(profileSelector);
  const profile = profileInfo?.data?.profile;
  const navigate = useNavigate();
  const urlParams = useParams();
  const webinarId = urlParams?.webinarId;
  const [searchTerm, setSearchTerm] = useState("");
  const [active, setActive] = useState(null);
  const [filteredWebinars, setFilteredWebinars] = useState([]);

  const { data, isLoading: loadingDetails } = useGetWebinarQuery(webinarId, {
    skip: webinarId ? false : true,
  });

  useEffect(() => {
    dispatch(getProviderProfile());
  }, [dispatch]);

  useEffect(() => {
    if (profile) {
      if (
        profile?.status?.toLowerCase() === "selected" ||
        profile?.status?.toLowerCase() === "application_completed" ||
        profile?.status?.toLowerCase() === "certified"
      ) {
        // eslint-disable-next-line no-unused-vars
        let r = true;
      } else {
        navigate(Path.FELLOW_DASHBOARD);
      }
    }
  }, [navigate, profile]);

  useEffect(() => {
    if (data) {
      setFilteredWebinars([...data?.data?.webinar?.episodes]);
    }
  }, [data]);

  const webinarDetails = data?.data?.webinar ?? null;

  return (
    <FellowLayout>
      {isLoading || loadingDetails ? (
        <div className="d-flex justify-content-center align-items-center height-15 bg-white ">
          <FadeLoader color="#36d7b7" />
        </div>
      ) : (
        <Fragment>
          <div className="row community-container">
            <Row>
              <Col xl="12">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <button
                    className="me-2 btn btn-white"
                    onClick={() => {
                      navigate(Path.COMMUNITY_WEBINARS);
                    }}
                  >
                    <BackIcon />
                    <span className="ms-1 text-grey">Back</span>
                  </button>
                  <div className="search-wrapper webinar-search">
                    <div className="search-icon">
                      <SearchIcon />
                    </div>
                    <input
                      type="text"
                      className="search-input"
                      placeholder="Search by title or description"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onKeyDown={(e) => {
                        const regex = new RegExp(e.target.value, "i");

                        const filteredEpisodes = webinarDetails.episodes.filter(
                          (episode) => {
                            return (
                              regex.test(episode.title) ||
                              regex.test(episode.description)
                            );
                          }
                        );

                        setFilteredWebinars(filteredEpisodes);
                      }}
                    />
                  </div>
                </div>
              </Col>
              <Col xl="12">
                <Card className="transparent">
                  {filteredWebinars?.length > 0 ? (
                    <div className="row">
                      {filteredWebinars?.map((webinar) => {
                        return (
                          <div
                            className="col-xl-4 col-md-6 webinar-card"
                            key={webinar?.id}
                          >
                            <div className="card all-crs-wid">
                              <div className="card-body">
                                <div className="courses-bx single-webinar">
                                  <div className="dlab-media">
                                    <img
                                      src={
                                        webinar?.thumbnail
                                          ? webinar?.thumbnail
                                          : course1
                                      }
                                      alt="course"
                                    />

                                    <button
                                      className="btn btn-white"
                                      onClick={() => setActive(webinar?.link)}
                                    >
                                      <PlayIcon />
                                      <span className="ms-1 text-primary">
                                        Watch Now
                                      </span>
                                    </button>
                                  </div>

                                  <div className="dlab-info">
                                    <div className="dlab-title d-flex justify-content-between">
                                      <div>
                                        <h4>
                                          <Link>
                                            {capitalize(webinar?.title)}
                                          </Link>
                                        </h4>
                                      </div>
                                    </div>
                                    <div className="">
                                      <p className="pb-0 mb-1">
                                        {dayjs(webinar?.date).format("MMMM D, YYYY")}
                                      </p>

                                      <Link
                                        className="btn btn-sm btn-watch"
                                        onClick={() => setActive(webinar?.link)}
                                      >
                                        <PlayIcon />
                                        <span className="ms-1 text-primary">
                                          Watch Now
                                        </span>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <Card.Body>
                      <EmptyNotice text="This webinar has no episode at the moment" />
                    </Card.Body>
                  )}
                </Card>
              </Col>
            </Row>
          </div>
        </Fragment>
      )}

      {active && (
        <ModalVideo
          channel="youtube"
          autoplay
          isOpen={true}
          onClose={() => setActive(null)}
          videoId={extractYouTubeVideoId(active)}
        />
      )}
    </FellowLayout>
  );
};

export default FellowWebinar;
